export default {
  // setAuth(state, payload) {
  //   state.loggedIn = payload;
  // },
  setPathFrom(state, payload) {
    state.pathFrom = payload;
  },
  setGoToBasket(state, payload) {
    state.goToBasket = payload;
  },
  setUser(state, payload) {
    state.user = Object.assign({}, payload);
  },
  setCompany(state, payload) {
    state.company = Object.assign({}, payload);
  },
  setService(state, payload) {
    state.service = Object.assign({}, payload);
  },
  setAcl(state, payload) {
    state.acl = Object.assign({}, payload);
  },
  setMinimumValueLimitation(state, payload) {
    state.minimumValueLimitation = Object.assign({}, payload);
  },
  changeNewsletter(state, payload) {
    if (state.acl) state.acl.subscribedToNewsletter = payload;
  },
  changeDefaultCostCenter(state, payload) {
    if (state.user.defaultCostCenter) state.user.defaultCostCenter = payload;
  },
  changeCountOrderForAcceptance(state, payload) {
    state.countOrderForAcceptance = payload;
  },
  setOtherAccounts(state, payload) {
    state.otherAccounts = payload;
  },
  setCurrentCompany(state, payload) {
    state.currentCompany = payload;
  },
};
